import React from 'react';

const AdminSignUpModale = ({ onLogin, toggleSignUpModal, toggleModal }) => {


    const handleFormSubmit = (e) => {
        e.preventDefault();
        onLogin();
    };

    const handleLogin = () => {
        toggleSignUpModal()
        toggleModal()
    }

    return (
        <div className="flex items-center justify-center h-screen">
            <div className="relative w-full items-center flex justify-center flex-col p-8 py-12 bg-[#F6F2EF] shadow-md rounded-3xl border border-gray-200">
                <h1 className="text-2xl font-bold text-center text-[#362269] p-1 rounded-lg mb-6  w-fit">ARE YOU IN ?</h1>

                <button className='absolute right-3 top-4 text-black' onClick={toggleSignUpModal}>
                    &#10006;
                </button>

                

                <form className='w-full' onSubmit={handleFormSubmit}>
                  
                        <div className="space-y-4">
                            <div>
                                <input
                                    type="text"
                                    placeholder="Organisation Name *"
                                    className="w-full px-4 py-4 bg-[#E6E6E6] outline-none rounded-2xl border-0 focus:ring-2 focus:ring-[#C6AFFF]"
                                />
                            </div>

                            <div>
                                <input
                                    type="email"
                                    placeholder="Organisation Email *"
                                    className="w-full px-4 py-4 bg-[#E6E6E6] outline-none rounded-2xl border-0 focus:ring-2 focus:ring-[#C6AFFF]"
                                />
                            </div>

                            <div>
                                <input
                                    type="password"
                                    placeholder="Password *"
                                    className="w-full px-4 py-4 bg-[#E6E6E6] outline-none rounded-2xl border-0 focus:ring-2 focus:ring-[#C6AFFF]"
                                />
                            </div>

                            <div className="flex flex-col justify-center items-center text-center">
                                <button
                                    type="button"
                                    className="common_btn "
                                    onClick={toggleSignUpModal}
                                    style={{ background: "#C6AFFF" }}
                                >
                                    Create Account
                                </button>
                            </div>

                            <div className='flex justify-between w-full'>
                                <span className='flex'>
                                    Already have a account? {" "} <button
                                        type="button"
                                        className="text-sm text-[#C6AFFF] hover:underline"
                                        onClick={handleLogin}
                                    >
                                        Log in
                                    </button>
                                </span>


                              
                            </div>
                        </div>


                   


                </form>
            </div>
        </div>
    );
};



export default AdminSignUpModale